export const GOLDEN_ASSET_KIND_VALUES = [
    "character_face",
    "character_angle",
    "character_outfit",
    "pov_hands",
    "location_master",
    "location_angle",
    "style_reference",
    "prop",
];
export const GoldenAssetKind = {
    CHARACTER_FACE: "character_face",
    CHARACTER_ANGLE: "character_angle",
    CHARACTER_OUTFIT: "character_outfit",
    POV_HANDS: "pov_hands",
    LOCATION_MASTER: "location_master",
    LOCATION_ANGLE: "location_angle",
    STYLE_REFERENCE: "style_reference",
    PROP: "prop",
};
export const GOLDEN_ASSET_KIND_LABELS = {
    [GoldenAssetKind.CHARACTER_FACE]: "Visage officiel",
    [GoldenAssetKind.CHARACTER_ANGLE]: "Angle de personnage",
    [GoldenAssetKind.CHARACTER_OUTFIT]: "Tenue",
    [GoldenAssetKind.POV_HANDS]: "Mains POV",
    [GoldenAssetKind.LOCATION_MASTER]: "Plan maître du lieu",
    [GoldenAssetKind.LOCATION_ANGLE]: "Angle du lieu",
    [GoldenAssetKind.STYLE_REFERENCE]: "Référence de style",
    [GoldenAssetKind.PROP]: "Accessoire",
};
export const GOLDEN_ASSET_STATUS_VALUES = ["candidate", "approved", "locked"];
export const GoldenAssetStatus = {
    CANDIDATE: "candidate",
    APPROVED: "approved",
    LOCKED: "locked",
};
export const GOLDEN_ASSET_STATUS_LABELS = {
    [GoldenAssetStatus.CANDIDATE]: "Candidat",
    [GoldenAssetStatus.APPROVED]: "Approuvé",
    [GoldenAssetStatus.LOCKED]: "Verrouillé",
};
export const GOLDEN_ASSET_OWNER_TYPE_VALUES = ["character", "location", "series"];
export const GoldenAssetOwnerType = {
    CHARACTER: "character",
    LOCATION: "location",
    SERIES: "series",
};
